var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_05-bus",
    "data-name": "05-bus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112,320a48,48,0,1,0,48,48A48.055,48.055,0,0,0,112,320Zm0,72a24,24,0,1,1,24-24A24,24,0,0,1,112,392Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.984,201.344l-28.437-42.656A23.949,23.949,0,0,0,457.578,148H28A24.028,24.028,0,0,0,4,172V324H71.265a59.854,59.854,0,0,1,81.47,0h206.53a59.854,59.854,0,0,1,81.47,0H508V208A11.992,11.992,0,0,0,505.984,201.344ZM200,228a12,12,0,0,1-12,12H64a12,12,0,0,1-12-12V178a12,12,0,0,1,12-12H188a12,12,0,0,1,12,12Zm176,0a12,12,0,0,1-12,12H236a12,12,0,0,1-12-12V178a12,12,0,0,1,12-12H364a12,12,0,0,1,12,12Zm112,55.3c-1.253.443-44,.7-44,.7a12,12,0,0,1-12-12V178a12,12,0,0,1,12-12h14.422l27.562,35.344A11.992,11.992,0,0,1,488,208Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460,368a59.61,59.61,0,0,1-6.957,28H484a24.028,24.028,0,0,0,24-24V348H456.56A59.718,59.718,0,0,1,460,368Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.44,348H4v24a24.028,24.028,0,0,0,24,24H58.957a59.839,59.839,0,0,1-3.517-48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.44,348H168.56a59.839,59.839,0,0,1-3.517,48H346.957a59.839,59.839,0,0,1-3.517-48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,320a48,48,0,1,0,48,48A48.055,48.055,0,0,0,400,320Zm0,72a24,24,0,1,1,24-24A24,24,0,0,1,400,392Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.06e9f2e0.svg";
export { ForwardRef as ReactComponent };